import * as yup from 'yup';
export const Deliveryschema = yup.object().shape({
  name: yup.string().required('Name is required'),
  phoneNumber: yup
    .string()
    .required('Phone number is required')
    .matches(/^[0-9+\-\s]+$/, 'Invalid phone number format'),
  street1: yup.string().required('Street1 is required'),
  street2: yup.string().nullable(),
  city: yup.string().required('City is required'),
  zipCode: yup.string().required('Zip code is required'),
  state: yup.string().required('State is required'),
});
